import { ImageModel } from "./imageModel";
import { ATCCodeModel } from "./atcCodeModel";

export class ActiveIngredientModel {
    public activeIngredientId: number;
    public activeIngredientName: string;
    public genericINNName: string;
    public commonChemicalName: string;
    public IUPACChemicalName: string;
    public molecularFormula: string;
    public shortDescription: string;
    public description: string;
    public currentActiveToMedStrength: string;
    public image: ImageModel;
    public atcCode: ATCCodeModel;
}
